"use strict";
/*
 * Created on 18. 9. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Basic type of price release.
 * @author Radek Beran
 */

var ReleaseType;

(function (ReleaseType) {
  /** Release determined for regular, urgent or super-fast pricing process. */
  ReleaseType["Regular"] = "Regular";
  /** Release determined only for Price team and it will be used only for simulation of impacts in new settings changes. */

  ReleaseType["Simulation"] = "Simulation";
  /** Release determined for sell-out pricing process (overstock, exit, expiry, etc.). */

  ReleaseType["Sellout"] = "Sellout";
})(ReleaseType = exports.ReleaseType || (exports.ReleaseType = {}));